import { render } from "./cuti-setting-list.vue?vue&type=template&id=c0b0b0fe"
import script from "./cuti-setting-list.vue?vue&type=script&lang=js"
export * from "./cuti-setting-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__